import { apiSlice } from 'store/slices/api';
import { ListResponse, QueryParams } from 'types/api';
import { CLIENT_V2_URLS } from 'store/slices/constants/clientV2';
import { parseQueryParams } from 'store/slices/utils';
import { ProgramLineSchema, ProgramSchema } from 'types/clientV2/programs';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPrograms: builder.query<
      ListResponse<ProgramSchema>,
      QueryParams<ProgramSchema>
    >({
      query: (params) => ({
        url: CLIENT_V2_URLS.PROGRAMS(parseQueryParams<ProgramSchema>(params)),
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(
                ({ id }: ProgramSchema) =>
                  ({
                    type: 'ProductionRuns',
                    id,
                  } as const)
              ),
              { type: 'ProductionRuns', id: 'LIST' },
            ]
          : [{ type: 'ProductionRuns', id: 'LIST' }],
    }),
    getProgramLines: builder.query<
      ListResponse<ProgramLineSchema>,
      QueryParams<ProgramLineSchema>
    >({
      query: (params) => ({
        url: CLIENT_V2_URLS.PROGRAM_LINES(
          parseQueryParams<ProgramLineSchema>(params)
        ),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(
                ({ id }: ProgramLineSchema) =>
                  ({
                    type: 'ProductionRunLines',
                    id,
                  } as const)
              ),
              { type: 'ProductionRunLines', id: 'LIST' },
            ]
          : [{ type: 'ProductionRunLines', id: 'LIST' }],
    }),
  }),
});

export const { usePrefetch, useGetProgramsQuery, useGetProgramLinesQuery } =
  extendedApiSlice;
